const CURRENCY_LOCALE = 'de-DE';
const CURRENCY_CODE = 'EUR';

const currencyFormatter = new Intl.NumberFormat(CURRENCY_LOCALE, {
  style: 'currency',
  currency: CURRENCY_CODE,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCurrency(value?: number | null): string {
  const parsed = Number(value ?? 0);
  const amount = Number.isFinite(parsed) ? parsed : 0;
  const parts = currencyFormatter.formatToParts(amount);
  const currencyIndex = parts.findIndex((p) => p.type === 'currency');
  if (currencyIndex === -1) return currencyFormatter.format(amount);

  const numberPartTypes = new Set([
    'integer',
    'fraction',
    'decimal',
    'group',
    'minusSign',
    'plusSign',
  ]);

  const hasNumberAfterCurrency = parts
    .slice(currencyIndex + 1)
    .some((p) => numberPartTypes.has(p.type));

  const nextIndex = currencyIndex + 1;
  if (hasNumberAfterCurrency) {
    if (parts[nextIndex]?.type === 'literal') {
      parts[nextIndex] = { ...parts[nextIndex], value: '\u00A0' };
    } else {
      parts.splice(nextIndex, 0, { type: 'literal', value: '\u00A0' });
    }
  } else {
    const prevIndex = currencyIndex - 1;
    if (parts[prevIndex]?.type === 'literal') {
      parts[prevIndex] = { ...parts[prevIndex], value: '\u00A0' };
    } else {
      parts.splice(currencyIndex, 0, { type: 'literal', value: '\u00A0' });
    }
  }

  return parts.map((p) => p.value).join('');
}
